export default __webpack_public_path__ + "static/media/boy.f8e4cfd4.png";